/**
 * 船舶検索を管理
 */
import state from './moduleEnterpriseMapVesselSearchState.js'
import mutations from './moduleEnterpriseMapVesselSearchMutations.js'
import actions from './moduleEnterpriseMapVesselSearchActions.js'
import getters from './moduleEnterpriseMapVesselSearchGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
